import React, { useState } from 'react';
import './Interview.css';
import AIInterview from '../../Assets/AI_Interview.png';
import AIInterview2 from '../../Assets/AI_Interview2.png';
import { useNavigate } from 'react-router-dom';

const Interview = ({ courseId ,courseName}) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const handleAIinterview = () => {
    setShowPopup(false);
    navigate(`/enrolledCourse/ai-interview/${courseId}/${courseName}`);
  }
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div> {
      showPopup &&
      <div className='overlay-ai-interview'>
        <div className='overlay-ai-interview-child'> <h3>Are you confident about taking the interview?</h3>
          <div>
            <button onClick={handleAIinterview}>Yes</button>  <button onClick={handleClosePopup}>No</button>
          </div>
        </div>
      </div>
    }
      <div className='Interview-guidelines-sub-container'>
        <div className='Interview-guidelines-content'>
          <h1 className='Interview-Heading'>Keep Going – You're Almost There!
            !</h1>
          <p>
            You're making great progress in your course! Whether you've completed all the modules or still have some left, you're on the right path. To move forward, you can choose to attend an interview to get feedback and guidance on your next steps. Choose between an AI interview or an Instructor interview at your convenience.

          </p>
          <p>            Keep up the great work – you’ve got this!
          </p>
        </div>
        <img src={AIInterview} alt='AI Interview illustration' />
      </div>

      <div className='Interview-guidelines-sub-container'>
        <img src={AIInterview2} alt='Another AI Interview illustration' />
        <div className='Interview-guidelines-content'>
          <h1 className='Interview-Heading'>Important Notes Before You Begin</h1>
          <p>1. To receive your certificate, completing the interview is mandatory.</p>
          <p>2. You can attempt the interview for free up to 3 times. After that, a fee of ₹100 will apply for every 3 additional attempts.</p>
          </div>
      </div>

      <div className='Interview-guidelines-options'>
        <h1>Choose the Interview Based on Your Convenience</h1>
        <div>
          <button onClick={() => setShowPopup(true)} className="ES-button">AI Interview</button>
          {/* <button onClick={() => navigate(`/enrolledCourse/instructor-interview/${courseId}`)}  className="ES-button">Instructor Interview</button> */}
        </div>
      </div>

    </div>
  );
};

export default Interview;
